import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { isEmptyArray } from '../common/util.services';
import './product-list.component.scss';
import { getAllProducts } from './product.services';

const ProductList = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [productData, setProductData] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'category', headerName: 'Category', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 180 },
    { field: 'subCode', headerName: 'Sub-Code', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'definition', headerName: 'Definition', filterable: false, sortable: false, editable: false, width: 750 },
  ];
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getAllProducts('', false, 0, 100, appContext,
        (response: any) => {
          setProductData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  },[]);

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={productData} columns={columns} loading={loading}
        paginationType="server" hideFooter={true} totalRows={totalRows}
        showAction={false} showAddBtn={false}
        getRowId={(row: any) => row.rowId} />
    </>
  }

  return <TitlePanel title='Products' panelBody={getMainPanel()} />
}

export default ProductList;